import {Client} from "../../types/userManagement";
import {err, ok, Result} from "neverthrow";
import {AutoCheckInConfigUpdateRequest, AutoCheckInError} from "./types";
import {apiV2} from "../../api/axiosConfig";
import {isAxiosError} from "axios";


export async function createDefaultAutoCheckInConfig(client: Client | undefined): Promise<Result<void, AutoCheckInError>>{
    if (!client) {
        return err({message:"no client set"});
    }

    try {
        await apiV2.post(`auto-check-in-config/create-default?clientID=${client.id}`)
    } catch(e){
        if (isAxiosError(e)){
            if(e?.response?.data?.error){
                return err({message: e.response.data.error})
            }
        }

        return err({message:"error creating default"});
    }


    return ok()
}

export async function createAutoCheckInConfig(client: Client | undefined, name: string): Promise<Result<void, AutoCheckInError>>{
    if (!client) {
        return err({message:"no client set"});
    }

    if(!name){
        return err({message:"no name set"});
    }

    try {
        await apiV2.post(`auto-check-in-config/create?clientID=${client.id}`, {name: name})
    } catch(e){
        if (isAxiosError(e)){
            if(e?.response?.data?.error){
                return err({message: e.response.data.error})
            }
        }

        return err({message:"error creating default"});
    }


    return ok()


}


export async function updateAutoCheckInConfig(profileID: string, request: AutoCheckInConfigUpdateRequest): Promise<Result<void, AutoCheckInError>>{
    if (!profileID) {
        return err({message:"no profile selected"});
    }

    try {
        await apiV2.patch(`auto-check-in-config/${profileID}`, request)
    } catch(e){
        if (isAxiosError(e)){
            if(e?.response?.data?.error){
                return err({message: e.response.data.error})
            }
        }

        return err({message:"error updating profile"});
    }


    return ok()


}


export async function deleteAutoCheckInConfig(profileID: string): Promise<Result<void, AutoCheckInError>>{
    if (!profileID) {
        return err({message:"no profile selected"});
    }

    try {
        await apiV2.delete(`auto-check-in-config/${profileID}`)
    } catch(e){
        if (isAxiosError(e)){
            if(e?.response?.data?.error){
                return err({message: e.response.data.error})
            }
        }

        return err({message:"error deleting profile"});
    }


    return ok()


}